import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=0f1aa208&scoped=true"
import script from "./CrudTable.vue?vue&type=script&lang=js"
export * from "./CrudTable.vue?vue&type=script&lang=js"
import style0 from "./CrudTable.vue?vue&type=style&index=0&id=0f1aa208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1aa208",
  null
  
)

export default component.exports